/**
 * Created by Victor Rojo on 17/10/18.
 */
import {Component, Input, ViewChild, TemplateRef, ViewContainerRef, DoCheck} from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NotificationsService }     from 'angular2-notifications';

import {WidgetService} from "../../widget/Widget.service";
import {SimpleGadget, GadgetTypes} from "../../gadget/Gadget";
import {RuleService} from "../../rule/Rule.service";
import {I18NService} from "../../../shared/i18n/i18n.service";
import {ElementService} from "../../element/Element.service";
import {AuthService} from "../../../shared/auth/auth.service";


@Component({
  selector: 'gadget',
  templateUrl: './Gadget.component.html',
  styleUrls: ['./Gadget.component.css']
})
export class GadgetComponent {
  private _gadget:SimpleGadget;
  _mapGadget:boolean = false;
  private busy = false;
  private edition = false;
  private modalRef:BsModalRef;
  private digitsInfo:string;
  private step:number = 0;
  private valueDisplay:string;
  private valueDisplayUnit:string;
  private valueTimeout:any;
  private valueUpdateTime:number;
  private elementDisplayValue:any;
  private consumptionMeterD2:string;
  private consumptionMeterD3:string;
  private needlePoints:string;
  private gaugeValue = 0;
  private elementGaugeValue = "0";
  private gaugeUpdateTime:number;
  private tooltipShowSection = false;
  private tooltipShowDate = false;
  private inverted = false;
  border = false;
  mousePosition = 75;
  @ViewChild("icon", {read: ViewContainerRef, static: true}) iconView:ViewContainerRef;
  @ViewChild('clickConfirmation', {static: true}) clickConfirmationTemplate:TemplateRef<any>;
  @ViewChild('busy', {static: false}) busyTemplate:TemplateRef<any>;
  @ViewChild('sensorIcon', {static: true}) sensorIconTemplate:TemplateRef<any>;

  @ViewChild('heatingIcon', {static: true}) heatingIconTemplate:TemplateRef<any>;
  @ViewChild('lightIcon', {static: true}) lightIconTemplate:TemplateRef<any>;
  @ViewChild('motionSensorIcon', {static: true}) motionSensorIconTemplate:TemplateRef<any>;
  @ViewChild('temperatureSensorIcon', {static: true}) temperatureSensorIconTemplate:TemplateRef<any>;
  @ViewChild('consumptionMeterIcon', {static: true}) consumptionMeterIconTemplate:TemplateRef<any>;
  @ViewChild('socketIcon', {static: true}) socketIconTemplate:TemplateRef<any>;
  @ViewChild('nasIcon', {static: true}) nasIconTemplate:TemplateRef<any>;
  @ViewChild('pushButtonIcon', {static: true}) pushButtonIconTemplate:TemplateRef<any>;
  @ViewChild('doorIcon', {static: true}) doorIconTemplate:TemplateRef<any>;
  @ViewChild('powerSupplyIcon', {static: true}) powerSupplyIconTemplate:TemplateRef<any>;
  @ViewChild('manualPushButtonIcon', {static: true}) manualPushButtonIconTemplate:TemplateRef<any>;
  @ViewChild('aucaExtinguisherIcon', {static: true}) aucaExtinguisherIconTemplate:TemplateRef<any>;
  @ViewChild('airConditionerIcon', {static: true}) airConditionerIconTemplate:TemplateRef<any>;
  @ViewChild('universalSwitchIcon', {static: true}) universalSwitchIconTemplate:TemplateRef<any>;
  @ViewChild('temperatureIcon', {static: true}) temperatureIconTemplate:TemplateRef<any>;
  @ViewChild('leakDetectorIcon', {static: true}) leakDetectorIconTemplate:TemplateRef<any>;
  @ViewChild('generalAlarmIcon', {static: true}) generalAlarmIconTemplate:TemplateRef<any>;
  @ViewChild('photocellIcon', {static: true}) photocellIconTemplate:TemplateRef<any>;
  @ViewChild('customizableIcon', {static: true}) customizableIconTemplate:TemplateRef<any>;
  @ViewChild('variatorIcon', {static: true}) variatorIconTemplate:TemplateRef<any>;
  @ViewChild('adjustableBlind', {static: true}) adjustableBlind:TemplateRef<any>;
  @ViewChild('emergencySignalIcon', {static: true}) emergencySignalIconTemplate:TemplateRef<any>;
  @ViewChild('statusIcon', {static: true}) statusIconTemplate:TemplateRef<any>;
  @ViewChild('lockIcon', {static: true}) lockIconTemplate:TemplateRef<any>;
  @ViewChild('valveIcon', {static: true}) valveIconTemplate:TemplateRef<any>;
  @ViewChild('pumpIcon', {static: true}) pumpIconTemplate:TemplateRef<any>;

  constructor(private widgetService:WidgetService,
              private authService:AuthService,
              private ruleService:RuleService,
              private elementService:ElementService,
              private modalService:BsModalService,
              private i18nService:I18NService,
              private notificationService:NotificationsService,
              private ref:ChangeDetectorRef) {
  }

  get gadget():SimpleGadget {
    return this._gadget;
  }

  @Input()
  set gadget(gadget:SimpleGadget) {
    this._gadget = gadget;
    this.updateSVGIcon();
    this.updateDigitsInfo();
    this.updateTooltipVisbility();
    if (gadget.gadgetTypeId == GadgetTypes.CONSUMPTION_METER) {
      this.updateGauge();
    } else if (gadget.gadgetTypeId == GadgetTypes.VARIATOR) {
      this.configVariator();
      this.updateValueDisplay();
    } else if (gadget.gadgetTypeId == GadgetTypes.TEMPERATURE) {
      this.configTemperature();
      this.updateValueDisplay();
    } else if (gadget.gadgetTypeId == GadgetTypes.ADJUSTABLE_BLIND) {
      this.configAdjustableBlind();
    }
  }

  @Input()
  set mapGadget(mapGadget:boolean) {
    this._mapGadget = mapGadget;
    this.border = mapGadget;
  }

  gadgetOnClick() {
    if (!this.busy) {
      if (this._gadget.clickConfirmation) {
        this.modalRef = this.modalService.show(this.clickConfirmationTemplate, {class: this.authService.getVertical()});
      } else {
        this.executeRule(null);
      }
    }
  }

  confirmExecuteRule() {
    this.setBusy(true);
    this.executeRule(null);
  }

  executeRule(ruleId:string) {
    let promise;
    if (ruleId) {
      this.setBusy(true);
      promise = this.ruleService.executeRule(ruleId);
    } else if (this._gadget.rules && this._gadget.rules.length) {
      this.setBusy(true);
      let rule = this._gadget.rules[0];
      promise = this.ruleService.executeRule(rule);
    }
    if (promise) {
      promise.then(() => {
        this.setBusy(false);
      }).catch(() => {
        this.setBusy(false);
        this.notificationService.error(
          this.i18nService.get("error"),
          this.i18nService.get("cantExecuteAction") + " " + this._gadget.tagTitle
        );
      });
    }
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  setBusy(busy:boolean) {
    this.busy = busy;
  }

  updateSVGIcon() {
    this.iconView.clear();
    let view = null;
    if (this._gadget.gadgetTypeId == GadgetTypes.SENSOR) {
      view = this.sensorIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.HEATING) {
      view = this.heatingIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.LIGHT) {
      view = this.lightIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.MOTION_SENSOR) {
      view = this.motionSensorIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.TEMPERATURE_SENSOR) {
      view = this.temperatureSensorIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.CONSUMPTION_METER) {
      view = this.consumptionMeterIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.SOCKET) {
      view = this.socketIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.NAS) {

    } else if (this._gadget.gadgetTypeId == GadgetTypes.PUSH_BUTTON) {
      view = this.pushButtonIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.DOOR) {
      view = this.doorIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.POWER_SUPPLY) {
      view = this.powerSupplyIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.MANUAL_PUSH_BUTTON) {
      view = this.manualPushButtonIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.AUCA_EXTINGUISHER) {
      view = this.aucaExtinguisherIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.AIR_CONDITIONER) {
      view = this.airConditionerIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.UNIVERSAL_SWITCH) {
      view = this.universalSwitchIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.TEMPERATURE) {
      view = this.temperatureIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.LEAK_DETECTOR) {
      view = this.leakDetectorIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.GENERAL_ALARM) {
      view = this.generalAlarmIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.PHOTOCELL) {
      view = this.photocellIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.CUSTOMIZABLE) {
      view = this.customizableIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.VARIATOR) {
      view = this.variatorIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.ADJUSTABLE_BLIND) {
      view = this.adjustableBlind.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.EMERGENCY_SIGNAL) {
      view = this.emergencySignalIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.STATUS) {
      view = this.statusIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.LOCK) {
      view = this.lockIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.VALVE) {
      view = this.valveIconTemplate.createEmbeddedView(null);
    } else if (this._gadget.gadgetTypeId == GadgetTypes.PUMP) {
      view = this.pumpIconTemplate.createEmbeddedView(null);

    }

    if (view) {
      this.iconView.insert(view);
    }
  }

  updateDigitsInfo() {
    let intDigits = 1;
    let decimalDigits = 2;
    if (this._gadget.gadgetTypeId == GadgetTypes.TEMPERATURE) {
      decimalDigits = 1;
    } else if (this._gadget.decimalPrecision) {
      if (this._gadget.decimalPrecision.indexOf(".") != -1) {
        let tokens = this._gadget.decimalPrecision.split(".");
        if (tokens.length > 1) {
          intDigits = (tokens[0].match(/1/g) || []).length + (tokens[0].match(/#/g) || []).length;
          decimalDigits = (tokens[1].match(/1/g) || []).length + (tokens[1].match(/#/g) || []).length;
        } else {
          intDigits = (tokens[0].match(/1/g) || []).length + (tokens[0].match(/#/g) || []).length;
        }
      } else {
        decimalDigits = Number(this._gadget.decimalPrecision);
      }
    }
    this.digitsInfo = intDigits + "." + decimalDigits + "-" + decimalDigits;
  }

  updateTooltipVisbility() {
    let tagInformationType = this._gadget['tagInformationType'];
    if (tagInformationType) {
      this.tooltipShowSection = tagInformationType == 1 || tagInformationType == 3;
      this.tooltipShowDate = tagInformationType == 1 || tagInformationType == 2;
    }
  }

  configVariator() {
    if (this._gadget.gadgetTypeId == GadgetTypes.VARIATOR && this._gadget.literal) {
      let tokens = this._gadget.literal.split(";");
      if (tokens != null && tokens.length >= 2) {
        this.step = Number(tokens[1]);
        this.valueDisplayUnit = tokens[0];
      }
    }
    this.elementDisplayValue = this._gadget.elements[0];
  }

  configTemperature() {
    if (this._gadget.gadgetTypeId == GadgetTypes.TEMPERATURE) {
      this.step = 0.5;
      this.valueDisplayUnit = "º";
      this.elementDisplayValue = this._gadget.elements[1];
    }
  }

  configAdjustableBlind(){
    if (this._gadget.gadgetTypeId == GadgetTypes.ADJUSTABLE_BLIND) {
      this.inverted = this._gadget.options['inverted'] == '1';
    }
  }

  valueIncrease() {
    if (!this.busy) {
      this.edition = true;
      let value = Number(this.valueDisplay) + this.step;
      this.valueDisplay = value.toString();
      this.valueUpdateTime = (new Date()).getTime();
      this.updateValue(value);
    }
  }

  valueDecrease() {
    if (!this.busy) {
      this.edition = true;
      let value = Number(this.valueDisplay) - this.step;
      this.valueDisplay = value.toString();
      this.valueUpdateTime = (new Date()).getTime();
      this.updateValue(value);
    }
  }

  variatorChange(valueDisplay, event) {
    if (!this.busy) {
      this.edition = true;
      let value = this.parseNumber(valueDisplay);
      if (value != this.elementDisplayValue.value) {
        this.valueDisplay = value.toString();
        this.valueUpdateTime = (new Date()).getTime();
        this.updateValue(value);
      }
    }
    event.preventDefault();
  }

  parseNumber(strg) {
    var strg = strg || "";
    var decimal = '.';
    strg = strg.replace(/[^-?0-9$.,]/g, '');
    if (strg.indexOf(',') > strg.indexOf('.')) decimal = ',';
    if ((strg.match(new RegExp("\\" + decimal, "g")) || []).length > 1) decimal = "";
    if (decimal !== "" && (strg.length - strg.indexOf(decimal) - 1 == 3) && strg.indexOf("0" + decimal) !== 0) decimal = "";
    strg = strg.replace(new RegExp("[^-?0-9$" + decimal + "]", "g"), "");
    strg = strg.replace(',', '.');
    return parseFloat(strg);
  }

  onlyNumber(e) {
    var x = e.charCode || e.keyCode;
    let char = String.fromCharCode(e.which);
    if (isNaN(char as any) && x != 46 && x != 45 || x === 32 || x === 13 || (x === 46 && e.currentTarget.innerText.includes('.'))) e.preventDefault();

  }

  unredo(e) {
    this.valueDisplay = "";
    this.ref.detectChanges();
    this.updateValueDisplay();
  }

  private updateValue(value:any) {
    if (this.valueTimeout != null) {
      clearTimeout(this.valueTimeout);
      this.valueTimeout = null;
    }

    this.valueTimeout = setTimeout(()=> {
      this.setBusy(true);
      this.elementService.setElementValue(this.elementDisplayValue.elementId, value)
        .then(res => {
          this.setBusy(false);
          this.edition = false;
        }, error => {
          this.setBusy(false);
          this.edition = false;
          this.updateValueDisplay();
          this.notificationService.error(
            this.i18nService.get("error"),
            this.i18nService.get("cantExecuteAction") + " " + this._gadget.tagTitle
          );
        })
    }, 1000);
  }

  private updateValueDisplay() {
    if (this.elementDisplayValue) {
      this.valueDisplay = this.elementDisplayValue.value;
      this.valueUpdateTime = this.elementDisplayValue.updateDate;
    }
  }

  ngDoCheck() {
    if (this._gadget.gadgetTypeId == GadgetTypes.VARIATOR || this._gadget.gadgetTypeId == GadgetTypes.TEMPERATURE) {
      if (this.elementDisplayValue && this.valueDisplay != this.elementDisplayValue.value && this.valueUpdateTime < this.elementDisplayValue.updateDate) {
        this.updateValueDisplay();
      }
    } else if (this._gadget.gadgetTypeId == GadgetTypes.CONSUMPTION_METER) {
      if (this._gadget.elements[3] && this._gadget.elements[3].value != this.elementGaugeValue && this.gaugeUpdateTime < this._gadget.elements[3].updateDate) {
        this.updateGauge();
      }
    }
  }

  getGadgetContainerClass() {
    let klass = this._gadget.elements.every(x => !!x.status) ? "" : "error";
    if (this._mapGadget && ( this._gadget.gadgetTypeId == GadgetTypes.SENSOR || this._gadget.gadgetTypeId == GadgetTypes.CONSUMPTION_METER
      || this._gadget.gadgetTypeId == GadgetTypes.TEMPERATURE
      || this._gadget.gadgetTypeId == GadgetTypes.VARIATOR )) {
      klass += " fit";
    } else if (this._mapGadget && this._gadget.gadgetTypeId == GadgetTypes.CUSTOMIZABLE) {
      klass += "fit-left"
    } else if (this._mapGadget && this._gadget.gadgetTypeId == GadgetTypes.ADJUSTABLE_BLIND) {
      klass += "fit-hover"
    }
    return klass;
  }

  updateGauge() {
    let cx = 150;
    let cy = 300;
    let r1 = 150;

    if (this._gadget.elements.length > 6) {
      let maxValue = Number(this._gadget.elements[6].value);
      let elementValue = Number(this._gadget.elements[3].value);
      this.elementGaugeValue = this._gadget.elements[3].value;

      if (elementValue < 0) {
        elementValue = 0;
      }

      this.gaugeValue = Math.min(elementValue * 75 / maxValue, 100);
      this.gaugeUpdateTime = this._gadget.elements[3].updateDate;

      if (this.gaugeValue > 75) {
        this.consumptionMeterD2 = this.getGaugeArch(75, cx, cy, r1);
        this.consumptionMeterD3 = this.getGaugeArch(this.gaugeValue, cx, cy, r1);
      } else {
        this.consumptionMeterD2 = this.getGaugeArch(this.gaugeValue, cx, cy, r1);
        this.consumptionMeterD3 = this.getGaugeArch(0, cx, cy, r1);
      }
      this.needlePoints = this.getGaugeNeedle(this.gaugeValue, cx, cy, r1);
    }
  }

  private getGaugeArch(value, cx, cy, r1):string {
    let rad = Math.PI / 180;

    let pa = value * 1.8 - 180;
    let p:any = {};
    p.x = cx + r1 * Math.cos(pa * rad);
    p.y = cy + r1 * Math.sin(pa * rad);

    let x = p.x;
    let y = p.y;
    let lx = cx - x;
    let ly = cy - y;

    let a = Math.atan2(ly, lx) / rad - 180;


    let offset = 0;
    let delta = 60;


    a *= rad;
    var r2 = r1 - delta;
    var x4 = cx + r1 * Math.cos(a);
    var y4 = cy + r1 * Math.sin(a);
    var x5 = cx + r2 * Math.cos(a);
    var y5 = cy + r2 * Math.sin(a);

    var x2 = offset,
      y2 = cy;

    var d =
      "M " + x4 + ", " + y4 + " A" + r1 + "," + r1 + " 0 0 0 " + x2 + "," + y2 + " H" + (offset + delta) + " A" + r2 + "," + r2 + " 0 0 1 " + x5 + "," + y5 + " z";
    return d;
  }

  private getGaugeNeedle(value, cx, cy, r1) {
    let rad = Math.PI / 180;
    let pa = value * 1.8 - 180;

    let x = cx + r1 * Math.cos(pa * rad);
    let y = cy + r1 * Math.sin(pa * rad);
    let lx = cx - x;
    let ly = cy - y;
    let a = Math.atan2(ly, lx) / rad - 180;

    var nx1 = cx + 15 * Math.cos((a - 90) * rad);
    var ny1 = cy + 15 * Math.sin((a - 90) * rad);


    var nx2 = cx + 80 * Math.cos(a * rad);
    var ny2 = cy + 80 * Math.sin(a * rad);

    var nx3 = cx + 15 * Math.cos((a + 90) * rad);
    var ny3 = cy + 15 * Math.sin((a + 90) * rad);

    return nx1 + "," + ny1 + " " + nx2 + "," + ny2 + " " + nx3 + "," + ny3;
  }


  setAdjustableBlindBackground(event) {
    let convertFactor = this._mapGadget ? 0.968 : 0.7667
    let circleHeight = event.currentTarget.viewportElement.clientHeight * convertFactor;
    let yPercent = event.offsetY * 100 / circleHeight;
    if (yPercent <= 25) {
      this.mousePosition = 25;
    }
    else if (yPercent <= 50) {
      this.mousePosition = 50;
    }
    else if (yPercent <= 75) {
      this.mousePosition = 75;
    } else {
      this.mousePosition = 100;
    }
  }

  setAdjustableBlindTopValue() {
    let value = this.inverted ? 100 : 0;
    this.setAdjustableBlindOutput(value);
  }

  setAdjustableBlindBottomValue() {
    let value = this.inverted ? 0 : 100;
    this.setAdjustableBlindOutput(value);
  }

  stopAdjustableBlind() {
    this.setAdjustableBlindOutput(-1);
  }

  setAdjustableBlindValue() {
    let value = this.inverted ? 100 - this.mousePosition : this.mousePosition;
    this.setAdjustableBlindOutput(value);
  }


  private setAdjustableBlindOutput(value) {
    this.elementService.setElementValue(this._gadget.elements[1].elementId, value)
      .then(res => {
        this.edition = false;
      }, error => {
        this.notificationService.error(
          this.i18nService.get("error"),
          this.i18nService.get("cantExecuteAction") + " " + this._gadget.tagTitle
        );
      })
  }
  //GadgetTypes.SENSOR // 1
  //GadgetTypes.LIGHT // 4
  //GadgetTypes.HEATING // 6 Calefaccion
  //GadgetTypes.MOTION_SENSOR // 7
  //GadgetTypes.TEMPERATURE_SENSOR // 8
  //GadgetTypes.SOCKET // 10
  //GadgetTypes.NAS // 11 NO
  //GadgetTypes.PUSH_BUTTON // 13
  //GadgetTypes.DOOR // 14
  //GadgetTypes.POWER_SUPPLY // 16
  //GadgetTypes.MANUAL_PUSH_BUTTON // 19
  //GadgetTypes.AUCA_EXTINGUISHER // 20
  //GadgetTypes.AIR_CONDITIONER // 21
  //GadgetTypes.UNIVERSAL_SWITCH // 25
  //GadgetTypes.PHOTOCELL // 39
  //GadgetTypes.CUSTOMIZABLE // 45
  //GadgetTypes.VARIATOR // 46
  //GadgetTypes.STATUS// 48
  //GadgetTypes.LOCK // 52
  //GadgetTypes.VALVE // 53
  //GadgetTypes.PUMP // 54


  //BUTTON:2,
  //WINDOW:3,
  //BLIND:5,
  //CONSUMPTION_METER:9,
  //NAS:11,
  //CAMERA:12,
  //RESET:15,
  //LIGHT_SENSOR:17,
  //SAFE:18,
  //IRRIGATION:22,
  //HEATING_CIRCUIT:23,
  //TEMPERATURE:24,
  //TURN_ON_ALARM:26,
  //GAS_DETECTOR_PERCENT:27,
  //GAS_DETECTOR_PPM:28,
  //GAS_GROUP:29,
  //GAS_CENTRAL_ZONE:30,
  //FIRE_CENTRAL_ZONE:31,
  //FIRE_DETECTOR_1:32,
  //FIRE_DETECTOR_2:33,
  //FIRE_DETECTOR_3:34,
  //FIRE_DETECTOR_4:35,
  //FIRE:36,
  //LEAK_DETECTOR:37,
  //GENERAL_ALARM:38,
  //PLAYER:40,
  //INTERCOM:41,
  //BOX:42,
  //EMERGENCY_SIGNAL:43,
  //MAINTENANCE:44,
  //ADJUSTABLE_BLIND:47,
  //LABEL:49,
  //DIMMER:50,
  //ETHERNET:51,


  //GadgetTypes.TEMPERATURE // 24 Clima (no por el momento, requiere hacer un update directo del elemento)


}
